import { type ContentTextComponentProps } from "@client/content/types";
import Component from "@client/controls/HTML/component";
import React from "react";

export type TextComponentItemProps = ContentTextComponentProps;

export default (props: TextComponentItemProps) => <Component {...props} />;
